"use client";

import { ContentfulLivePreview } from "@contentful/live-preview";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import clsx from "clsx";

import { isSection, removeDelimiter } from "@/lib/ingredientFunctions";
import { affiliateRegex } from "@/lib/getChicorySchema";

export function createAffiliateLinkIfNeeded(str: string) {
  const match = str.match(affiliateRegex);

  if (match) {
    // match[1] is everything before {} , match[2] is the group in {}, match[3] is the group in [] and match[4] is the group in ()
    // match[5] is everything after ()

    // return everything before {} + group in [] linking to group in () + everything after ()
    return (
      <>
        {match[1]}
        <a className="text-theme-primary underline" href={match[4]}>
          {match[3]}
        </a>
        {match[5]}
      </>
    );
  } else {
    return str;
  }
}
export default function RecipeIngredientList({ recipe }: { recipe: Recipe }) {
  const updateRecipe = useContentfulLiveUpdates(recipe);
  return (
    <ul
      className="mx-4"
      {...ContentfulLivePreview.getProps({
        entryId: recipe?.sys.id,
        fieldId: "title",
      })}
    >
      {updateRecipe?.ingredients?.map((item: any, index: number) => (
        <li
          key={`ingredient-${index}`}
          className={clsx(
            "list-inside break-inside-avoid",
            isSection(item)
              ? "list-none font-bold leading-loose"
              : "list-disc leading-normal",
          )}
        >
          {isSection(item)
            ? removeDelimiter(item)
            : createAffiliateLinkIfNeeded(item.value)}
        </li>
      ))}
    </ul>
  );
}
